import { render, staticRenderFns } from "./realTimeKanban.vue?vue&type=template&id=1b95c565&scoped=true&"
import script from "./realTimeKanban.vue?vue&type=script&lang=js&"
export * from "./realTimeKanban.vue?vue&type=script&lang=js&"
import style0 from "./realTimeKanban.vue?vue&type=style&index=0&id=1b95c565&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b95c565",
  null
  
)

export default component.exports